import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { DomainsForTable } from '../..'
import { domainsFromDTO, sortToDTO } from './mapper'
import { GET_DOMAINS_FOR_TABLE } from './query'
import { Data, DomainsForTableDTO, UseGetDomains, UseGetDomainsProps, Variables } from './types'

export const useGetDomains = ({
  filters,
  first,
  last,
  sort,
}: UseGetDomainsProps): UseGetDomains => {
  const { workspaceId } = useWorkspaceParam()
  const [domains, setDomains] = useState<DomainsForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        domains: { nodes: domains, totalCount: count },
      } = data

      if (domains) {
        setDomains(
          domains.map((domain: DomainsForTableDTO): DomainsForTable => domainsFromDTO(domain)),
        )
        setCount(count)
      }
    },
    options: {
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
    },
    query: GET_DOMAINS_FOR_TABLE,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return { count, domains, loading }
}
